import { gsap } from "gsap";

export class AbstractTimelineController {
    /* eslint-disable no-undef */
    private timelineBtn: HTMLElement;

    private startSymbolIcon: HTMLElement;
    private stopSymbolIcon: HTMLElement;

    private isStopped: boolean = false;

    constructor() {
        this.timelineBtn = this.createBtn();
        this.startSymbolIcon = this.createSvgElement(this.startSvgDefinition);
        this.startSymbolIcon.style.display = `none`;
        this.stopSymbolIcon = this.createSvgElement(this.stopSVGDefinition);

        this.timelineBtn.appendChild(this.startSymbolIcon);
        this.timelineBtn.appendChild(this.stopSymbolIcon);

        document.body.appendChild(this.timelineBtn);

        this.timelineBtn.addEventListener(`click`, this.onClick.bind(this));
    }

    private onClick(): void {
        this.isStopped = !this.isStopped;

        this.startSymbolIcon.style.display = !this.isStopped ? `none` : `block`;
        this.stopSymbolIcon.style.display = this.isStopped ? `none` : `block`;

        if (this.isStopped) {
            gsap.globalTimeline.pause();
        } else {
            gsap.globalTimeline.resume();
        }
    }

    private createBtn(): HTMLElement {
        const btn = document.createElement(`div`);

        const btnText = document.createElement(`div`);
        btnText.style.fontSize = `20px`;
        btnText.style.marginRight = `10px`;
        btnText.innerText = `Timeline Controller`;
        btn.appendChild(btnText);

        btn.style.position = `absolute`;
        btn.style.width = `min-content`;
        btn.style.left = `-103px`;
        btn.style.top = `0px`;
        btn.style.border = `2px solid white`;
        btn.style.borderRadius = `10px`;
        btn.style.background = `#00000066`;
        btn.style.display = `flex`;
        btn.style.color = `white`;
        btn.style.padding = `10px`;
        btn.style.alignItems = `center`;
        btn.style.cursor = `pointer`;
        btn.style.userSelect = `none`;

        return btn;
    }

    private createSvgElement(svgDefinition: string): HTMLElement {
        const parsedData = new DOMParser().parseFromString(svgDefinition, `application/xml`);
        const svg = parsedData.documentElement as HTMLOrSVGImageElement;
        const el = document.createElement(`div`);
        el.appendChild(svg);

        svg.style.width = `60px`;
        svg.style.height = svg.style.width;

        return el;
    }

    private get startSvgDefinition(): string {
        return `<svg xmlns='http://www.w3.org/2000/svg' width='100.008' height='100.007' viewBox='0 0 100.008 100.007'><defs><style>.cls-1{opacity:0.4;}.cls-2{fill:#fff;}</style></defs><title>autoPlay</title><g id='Layer_2' data-name='Layer 2'><g id='Ring'><circle class='cls-1' cx='50.004' cy='50.004' r='50.004'/><path class='cls-2' d='M50,93.011a43,43,0,1,1,43-43A43.048,43.048,0,0,1,50,93.011Zm0-79.266A36.266,36.266,0,1,0,86.27,50.011,36.307,36.307,0,0,0,50,13.745Z'/></g><g id='AP'><path class='cls-2' d='M38,64.986V35.022a5.072,5.072,0,0,1,7.958-4.117L67.823,45.887a4.975,4.975,0,0,1,0,8.233L45.962,69.1A5.072,5.072,0,0,1,38,64.986Z'/></g></g></svg>`;
    }

    private get stopSVGDefinition(): string {
        return `<svg xmlns='http://www.w3.org/2000/svg' width='100.008' height='100.007' viewBox='0 0 100.008 100.007'><defs><style>.cls-1{opacity:0.4;}.cls-2{fill:#fff;}</style></defs><title>autoPlayStop</title><g id='Layer_2' data-name='Layer 2'><g id='Ring'><circle class='cls-1' cx='50.004' cy='50.004' r='50.004'/><path class='cls-2' d='M50,93.011a43,43,0,1,1,43-43A43.048,43.048,0,0,1,50,93.011Zm0-79.266A36.266,36.266,0,1,0,86.27,50.011,36.307,36.307,0,0,0,50,13.745Z'/></g><g id='AP'><rect class='cls-2' x='32.504' y='32.511' width='35' height='35' rx='6'/></g></g></svg>`;
    }
}
